"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgObjects = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_OBJECTS", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M12 6a4 4 0 0 0-8 0c0 .97.43 1.784 1.15 2.835l.222.32c.197.283.421.604.628.928V10h4v.083c.207-.324.43-.645.628-.929.08-.113.154-.22.222-.32C11.57 7.785 12 6.97 12 6Zm-2.515 5h-2.97c.142.3.272.634.362 1h2.246c.09-.366.22-.7.362-1ZM8 14a1 1 0 0 0 1-1H7a1 1 0 0 0 1 1ZM8 0a6 6 0 0 1 6 6c0 1.814-.94 3.165-1.769 4.353C11.581 11.287 11 12.12 11 13a3 3 0 1 1-6 0c0-.88-.58-1.713-1.231-2.647C2.94 9.165 2 7.814 2 6a6 6 0 0 1 6-6Z" }))); };
exports.default = SvgObjects;
